import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { ongletOuvert } from './navigation';

/**
 * L'onglet d'un écran, porté par l'adresse (`?onglet=`) : le lien se
 * partage, et le retour du navigateur revient à l'onglet précédent
 * (Yros/Kavero#416).
 *
 * L'onglet ouvert ne prend de valeur que dans `onglets` : un onglet refusé
 * tapé dans l'URL ouvre le premier. La liste reste la seule barrière.
 */
export default function useOnglet(onglets) {
  const [parametres, setParametres] = useSearchParams();
  const actif = ongletOuvert(onglets, parametres.get('onglet'));

  const choisir = useCallback(
    (id, options) => {
      setParametres((courants) => {
        const suivants = new URLSearchParams(courants);
        suivants.set('onglet', id);
        return suivants;
      }, options);
    },
    [setParametres]
  );

  return [actif, choisir];
}
